import React, {useContext, useEffect, useState} from 'react';
import { Field } from 'react-final-form';
import RadioButton from '../Shared/RadioBig';
import Grid from "@material-ui/core/Grid";
import Select from "../Shared/Select";
import styled, {css} from "styled-components";
import { Trans } from "../utils/i18n";
import TextInput from "../Shared/TextInput";
import {Button, FormControl, FormControlLabel, FormLabel, RadioGroup} from "@mui/material";
import {useMutation} from "@tanstack/react-query";
import {Alert} from "@material-ui/lab";
import ErrorIcon from '@mui/icons-material/Error';
import Radio from "../Shared/Radio";
import {useFormState, useFormStateDispatch} from "./FormState";
import i18n from "i18next";

const SuccessWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.25);
    margin: 3rem auto;
    text-align: center;
    padding: 2rem 1rem;
    width: 100%;

    @media (min-width: 768px) {
        padding: 2rem 5rem;
        width: 80%;
    }

    ${props => props.marginTop && css`
        margin-top: ${props.marginTop}rem;
    `}
`;

const ErrorWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.25);
    margin: 0 auto;
    text-align: center;
    background: #f8d7da;
    padding: 2rem 1rem;
    width: 100%;
    margin-top: -1.5rem;

    @media (min-width: 768px) {
        padding: 2rem 5rem;
        width: 60%;
    }
`;

const InputRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: start;
    gap: 1rem;
`;

export function VerifyPhoneNumber ({ product, form, values, }) {
    const orderEntryDispatch = useFormStateDispatch();
    const { verificationRequest, verificationCodeResponse } = useFormState();
    const addPhoneMutation = useMutation({
        mutationFn: newTodo => axios.post(route('smsverification.addPhoneNumber'), newTodo),
    });
    const mutation = useMutation({
        mutationFn: newTodo => axios.post(route('smsverification.verify'), newTodo),
    });

    if(verificationCodeResponse) {
        return (
            <SuccessWrapper>
                <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M46.666 27.9994C46.666 32.9501 44.6994 37.698 41.1987 41.1987C37.698 44.6994 32.9501 46.666 27.9994 46.666C23.0486 46.666 18.3007 44.6994 14.8 41.1987C11.2993 37.698 9.33268 32.9501 9.33268 27.9994C9.33268 23.0486 11.2993 18.3007 14.8 14.8C18.3007 11.2993 23.0486 9.33268 27.9994 9.33268C29.7727 9.33268 31.4993 9.58935 33.1327 10.056L36.796 6.39268C34.0894 5.27268 31.126 4.66602 27.9994 4.66602C24.9352 4.66602 21.901 5.26955 19.0701 6.44216C16.2391 7.61477 13.6669 9.33349 11.5002 11.5002C7.12434 15.876 4.66602 21.811 4.66602 27.9994C4.66602 34.1877 7.12434 40.1227 11.5002 44.4985C13.6669 46.6652 16.2391 48.3839 19.0701 49.5565C21.901 50.7292 24.9352 51.3327 27.9994 51.3327C34.1877 51.3327 40.1227 48.8744 44.4985 44.4985C48.8744 40.1227 51.3327 34.1877 51.3327 27.9994M18.456 23.5194L15.166 26.8327L25.666 37.3327L48.9994 13.9993L45.7094 10.686L25.666 30.7294L18.456 23.5194Z" fill="#25CD21"/>
                </svg>

                <h2>
                    <Trans>
                        <Trans i18nKey="orderEntry.verificationCode.success">
                            Verification successful
                        </Trans>
                    </Trans>
                </h2>

                <p style={{ margin: 0, }}>
                    <Trans>
                        <Trans i18nKey="orderEntry.verificationCode.success.text">
                            Thank you for verifying your contact details.
                        </Trans>
                    </Trans>
                </p>
            </SuccessWrapper>
        );
    }

    const verification_type = values.verification_type === 'sms' ? i18n.t(`orderEntry.verificationCode.aSMS`) : i18n.t(`orderEntry.verificationCode.aEmail`);
    const verification_text = values.verification_type === 'sms' ? values.phone : values.email;

    return (
        <div>
            <Grid container spacing={3}>
                <Grid item xs={12} sm={12}>
                    <p>
                        <h3>
                            <Trans i18nKey="orderEntry.verificationCode.info.title">
                                To continue with the request, you must verify your information
                            </Trans>
                        </h3>
                    </p>
                    <p>
                        <Trans i18nKey="orderEntry.verificationCode.info.text">
                            To do this we need to send you a verification code. We can send you the code by e-mail or SMS
                        </Trans>
                    </p>
                    <div>
                        <Field
                            name={'verification_type'}
                            type={'radio'}
                            value={'email'}
                            component={Radio}
                            validate={value => (value ? undefined : <Trans i18nKey="common.required">Required</Trans>)}
                            field={{
                                label: 'Email',
                                titel: <>
                                    <Trans i18nKey="orderEntry.verificationCode.emailTo">
                                        Receive the verification code via e-mail to
                                    </Trans>  <b>{values.email}</b>
                                </>,
                            }}
                        />

                        <Field
                            name={'verification_type'}
                            type={'radio'}
                            value={'sms'}
                            component={Radio}
                            validate={value => (value ? undefined : <Trans i18nKey="common.required">Required</Trans>)}
                            field={{
                                label: 'SMS',
                                titel: <>
                                    <Trans i18nKey="orderEntry.verificationCode.smsTo">
                                        Receive the verification code via SMS to the phone number
                                    </Trans> <b>{values.phone}</b></>,
                            }}
                        />
                    </div>
                </Grid>
            </Grid>
            <Grid container spacing={3}>
                <Grid item xs={12} sm={12} style={{ display: 'flex', justifyContent: 'center', }}>
                    <Button
                        onClick={() => {
                            mutation.reset();
                            addPhoneMutation.mutateAsync({
                                verification_type: values.verification_type,
                                phone_number: values.phone,
                                email: values.email,
                                name: values.private_or_company === 'private' ? `${values.first_name} ${values.last_name}` : values.name,
                            })
                                .then(response => {
                                    orderEntryDispatch({type: 'verificationRequest', value: response});
                                })
                                .catch(error => {

                                });
                        }}
                        variant={'contained'}
                        disabled={addPhoneMutation.isLoading || !values?.verification_type}
                        id={'request-verification-code'}
                        color={'secondary'}
                    >
                        {
                            addPhoneMutation.isSuccess ?
                                <Trans i18nKey="orderEntry.verificationCode.RequestAnotherCode">
                                    Request another code
                                </Trans> :
                                <Trans i18nKey="orderEntry.verificationCode.RequestCode">
                                    Request verification code
                                </Trans>
                        }
                    </Button>
                </Grid>
            </Grid>
            {
                verificationRequest && (
                    <SuccessWrapper marginTop={3}>
                        <div>
                            <h2>
                                <Trans i18nKey="orderEntry.verificationCode.enterVerificationCode">
                                    Enter your verification code
                                </Trans>
                            </h2>
                            <p>
                                <Trans i18nKey="orderEntry.verificationCode.confirmation">
                                    We have sent {{verification_type}} to the address <b>{{verification_text}}</b> with an activation code. This code will be valid for 30 minutes.
                                </Trans>
                            </p>
                            <p>
                                <Trans i18nKey="orderEntry.verificationCode.enterBelow">
                                    Please enter it below
                                </Trans>:</p>
                        </div>
                        <InputRow>
                            <Field
                                name={'phone_verification_code'}
                                //placeholder={field.placeholder}
                                component={TextInput}
                                validate={value => (value ? undefined : <Trans i18nKey="productSelect.required">Required</Trans>)}
                                field={{
                                    label: <Trans i18nKey="orderEntry.verificationCode.verificationCode">Verification Code</Trans>,
                                    type: 'number'
                                }}
                                onEnter={(event) => {
                                    event.preventDefault();
                                    event.stopPropagation();
                                    mutation.mutateAsync({
                                        verification_code: form.getState().values.phone_verification_code,
                                        phone_number: form.getState().values.phone,
                                    })
                                        .then(response => {
                                            orderEntryDispatch({type: 'verificationCodeResponse', value: response});
                                            // document.querySelector('#formidtop')?.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
                                        })
                                        .catch(error => {

                                        });
                                }}
                            />
                            <Button
                                onClick={() => {
                                    mutation.mutateAsync({
                                        verification_code: form.getState().values.phone_verification_code,
                                        phone_number: form.getState().values.phone,
                                    })
                                        .then(response => {
                                            orderEntryDispatch({type: 'verificationCodeResponse', value: response});
                                            // document.querySelector('#formidtop')?.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
                                        })
                                        .catch(error => {

                                        });
                                }}
                                variant={'contained'}
                                disabled={mutation.isSuccess}
                                id={'verify-code'}
                                color={'secondary'}
                            >
                                {
                                    mutation.isSuccess ? <Trans i18nKey="orderEntry.verificationCode.verified">Verified</Trans> : <Trans i18nKey="orderEntry.verificationCode.verify">Verify</Trans>
                                }
                            </Button>
                        </InputRow>
                        <div>
                            <p>
                                <Trans i18nKey="orderEntry.verificationCode.tryAgainMessage">
                                    You should receive the code within up to two minutes. If not, please check your inputs and try again.
                                </Trans>
                            </p>
                        </div>
                    </SuccessWrapper>
                )
            }
            {
                verificationRequest && mutation.isError && (
                    <ErrorWrapper>
                        <ErrorIcon />

                        <h2 style={{ margin: '.5rem 0'}}>
                            <Trans>
                                <Trans i18nKey="orderEntry.verificationCode.error">
                                    The code entered doesn’t match
                                </Trans>
                            </Trans>
                        </h2>

                        {/* <p style={{ margin: 0, }}>
                            <Trans>
                                <Trans i18nKey="orderEntry.verificationCode.error.text">
                                    If you need help you can <span style={{ textDecoration: 'underline'}}>chat with us</span>
                                </Trans>
                            </Trans>
                        </p> */}
                    </ErrorWrapper>
                )
            }
        </div>
    );
};

export default VerifyPhoneNumber;
